import './css/style.css';

import { cargarMenu } from './menu.js';

import {
    inicializarEmpleado
} from './fronend/mantenimiento/empleado/empleado.js';

import {
    inicializarDobles
} from "./fronend/Ingresos/dobles/dobles.js";



import {
    inicializarDepartamento
} from "./fronend/mantenimiento/departamento/departamento.js";



import {
    inicializarSalario
} from './fronend/mantenimiento/salario/salario.js';




import {
    inicializarHrextra
} from './fronend/Ingresos/hrsextra.js';




import {
    inicializarDecreto
} from './fronend/Ingresos/decreto/decreto.js';


import {
    inicializarProduccion
} from './fronend/Ingresos/produccion/produccion.js';




import {
    inicializarComisiones
} from './fronend/Ingresos/comisiones/comisiones.js';



import {
    inicializarIgss
} from './fronend/Egresos/igss/igss.js';






import {
    inicializarIsr
} from './fronend/Egresos/isr/isr.js';






import {
    inicializarAsociacion
} from './fronend/Egresos/asociacion/asociacion.js';




import {
    inicializarTienda
} from './fronend/Egresos/comercios/tienda.js';




import {
    inicializarProcesar
} from './fronend/procesar/procesar.js';






import {
    inicializarUsuario
} from './fronend/seguridad/usuario/usuario.js';





import {
    inicializarAcceso
} from './fronend/seguridad/acceso/acceso.js';


import {
    inicializarCumple
} from './fronend/reportes/cumple/cumple.js';





import {
    inicializarReportesigss
} from './fronend/reportes/igss/reportesigss.js';




import {
    inicializarReportespoliza
} from './fronend/reportes/poliza/poliza.js';






import {
    inicializarReportesisr
} from './fronend/reportes/isr/reportesisr.js';




import {
    inicializarLibro
} from './fronend/reportes/libro/libro.js';



import {
    inicializarSesion
} from './fronend/seguridad/inicioSesion/inicio.js';




import {
    inicializarAnticipo
} from './fronend/mantenimiento/anticipo/anticipo.js';












document.addEventListener(
    'DOMContentLoaded',
    () => {

        console.log('🚀 Aplicación iniciada');

        cargarMenu();

        inicializarEmpleado();
          inicializarDobles();
             inicializarDepartamento();
              inicializarHrextra();

              inicializarDecreto();
    inicializarProduccion();
    inicializarComisiones();
     inicializarIgss();
         inicializarIsr();
         inicializarAsociacion();
         inicializarTienda();
         inicializarProcesar();
          inicializarUsuario();
  inicializarAcceso();
  inicializarCumple();
  inicializarReportesigss();
   inicializarReportesisr();
       inicializarLibro();
          inicializarReportespoliza();
            inicializarSesion();
                inicializarAnticipo();
                  inicializarSalario();

        }
);